import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LearningCourseQuestion from "@/components/learning/LearningCourseQuestion.vue";
import { LearningCourseQuestionLogic } from "@/logic/learning/LearningCourseQuestionLogic";
import { useRoute } from 'vue-router'
import { computed, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { learningCourse, exists_unanswerd, learningCourseQuestion, learning_question_result, learningCourseQuestionLoading, sendAnswer, getLearningCourse, getLearningCourseQuestion } = LearningCourseQuestionLogic();
const route = useRoute();
const project_id = computed(() => Number(route.params.project_id));
const learning_course_id = computed(() => Number(route.params.learning_course_id))

const sendQuestionAnswer = (learning_id: number, answer_time: number, answer_ids: number[]) => {
  sendAnswer(project_id.value, learning_course_id.value, learning_id, answer_time, answer_ids)
}


onMounted(async (): Promise<void> => {
  getLearningCourse(project_id.value, learning_course_id.value)
});



return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "project-box" }, {
    default: _withCtx(() => [
      _createVNode(LearningCourseQuestion, {
        learning_course: _unref(learningCourse),
        learning_course_question: _unref(learningCourseQuestion),
        learning_question_result: _unref(learning_question_result),
        exists_unanswerd: _unref(exists_unanswerd),
        project_id: _unref(project_id),
        loading: _unref(learningCourseQuestionLoading),
        learning_course_id: _unref(learning_course_id),
        onLoadLearningCourseQuestion: _cache[0] || (_cache[0] = ($event: any) => (_unref(getLearningCourseQuestion)(_unref(project_id), _unref(learning_course_id)))),
        onSendAnswer: sendQuestionAnswer
      }, null, 8, ["learning_course", "learning_course_question", "learning_question_result", "exists_unanswerd", "project_id", "loading", "learning_course_id"])
    ]),
    _: 1
  }))
}
}

})